import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, withLatestFrom } from 'rxjs';
import * as fromUploader from '@app/client/uploader/store/reducers';
import { Store } from '@ngrx/store';
import { Customization } from '../../../shared/models/customization';
import { PrepareActions } from '@app/client/uploader/store/actions';
import { Logo } from '@app/shared/models/logo';
import { Background } from '@app/shared/models/background';

@Injectable({
    providedIn: 'root'
})
export class ResolveCustomizationService {

    constructor(
        private readonly store$: Store<fromUploader.State>,
    ) { }

    resolve(): Observable<{ customization: Customization, backgrounds: Background[], logos: Logo[] }> {

        const resolvedCustomization$ = new ReplaySubject<{ customization: Customization, backgrounds: Background[], logos: Logo[] }>();
        this.store$.pipe(
            withLatestFrom(
                this.store$.select(fromUploader.getCustomization),
                this.store$.select(fromUploader.getCustomizationLoading),
                this.store$.select(fromUploader.getCustomizationLoaded),
                this.store$.select(fromUploader.getCustomizationError),
                this.store$.select(fromUploader.getCustomizationBackgrounds),
                this.store$.select(fromUploader.getCustomizationBackgroundsLoading),
                this.store$.select(fromUploader.getCustomizationBackgroundsLoaded),
                this.store$.select(fromUploader.getCustomizationLogos),
                this.store$.select(fromUploader.getCustomizationLogosLoading),
                this.store$.select(fromUploader.getCustomizationLogosLoaded),
            ),
        ).subscribe(([store,
            customization, customizationLoading, customizationLoaded, customizationError,
            backgrounds, backgroundsLoading, backgroundsLoaded,
            logos, logosLoading, logosLoaded,
        ]) => {
            if ((backgrounds.length && logos.length) || customizationError) {
                resolvedCustomization$.next({ customization, backgrounds, logos });
            } else if (!customizationLoading && !customizationLoaded) {
                this.store$.dispatch(PrepareActions.loadCustomization());
            } else if (customization && !backgroundsLoading && !backgroundsLoaded) {
                this.store$.dispatch(PrepareActions.loadBackgrounds());
            } else if (customization && !logosLoading && !logosLoaded) {
                this.store$.dispatch(PrepareActions.loadLogos());
            }
        });

        return resolvedCustomization$.asObservable();
    }

}